export const tableNumber = (index: number, page: number) => {
  const pageNumber = page ? page : 1;
  return index + 1 + (10 * (pageNumber - 1) ?? 0);
};
